import React from 'react';
import { Box, Typography } from '@mui/material';
import { Button } from '../../../Components/MUIs';

export default function FileButton({
  onCancel,
  onClick,
  cancelText = '이전',
  saveText = '다음',
  cancelColor = '#776D6D',
  saveColor = '#57B84D',
  pageNumber,
  numPages,
  disabledNext = false,
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        my: 2,
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <button
        style={{
          width: '100%',
          height: 36,
          borderRadius: '5px',
          backgroundColor: 'transparent',
          border: `1px solid ${cancelColor}`,
          color: cancelColor,
          boxShadow:
            '0px 2px 3px -1px rgba(0,0,0,0.1), 0px 1px 0px 0px rgba(25,28,33,0.02), 0px 0px 0px 1px rgba(25,28,33,0.08)',
        }}
        onClick={onCancel}
      >
        {cancelText}
      </button>
      {pageNumber && numPages && (
        <Typography
          sx={{
            fontWeight: 'bold',
            mx: 6,
            whiteSpace: 'nowrap',
            fontSize: '18px',
          }}
        >
          {pageNumber} / {numPages}
        </Typography>
      )}

      <Button
        name={saveText}
        sx={{
          width: '100%',
          height: 36,
          borderRadius: '5px',
          backgroundColor: disabledNext ? '#E8E8E8' : saveColor,
          color: disabledNext ? '#A0A0A0' : '#fff',
          boxShadow:
            '0px 2px 3px -1px rgba(0,0,0,0.1), 0px 1px 0px 0px rgba(25,28,33,0.02), 0px 0px 0px 1px rgba(25,28,33,0.08)',
          cursor: disabledNext ? 'not-allowed' : 'pointer',
        }}
        onClick={disabledNext ? undefined : onClick}
        disabled={disabledNext}
      />
    </Box>
  );
}
